module.exports = __webpack_public_path__ + "img/logo.a560d3d2.jpg";